import { render } from "./defaultPage.vue?vue&type=template&id=687b4dae&scoped=true"
import script from "./defaultPage.vue?vue&type=script&lang=js"
export * from "./defaultPage.vue?vue&type=script&lang=js"

import "./defaultPage.vue?vue&type=style&index=0&id=687b4dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687b4dae"]])

export default __exports__